import { createSelector } from 'reselect';

export const makeSelectDenormEntity = (selectById, selectIds) => createSelector(
  selectById,
  selectIds,
  (objectsById, ids) => ids.map((id) => objectsById[id]),
);

export const makeSelectEntityWithIsSelected = (
  selectDenormEntity, selectSelectedEntityIds,
) => createSelector(
  [selectDenormEntity, selectSelectedEntityIds],
  (denormEntity, selectedEntityIds) => denormEntity.map((entity) => ({
    ...entity,
    isSelected: selectedEntityIds.includes(entity.id),
  })),
);

export const makeSelectEntityWithIsPresentAndPicked = (
  selectDenormEntity, selectPresentAccordingToModel, selectPresentAccordingToUser, selectIsPickedDuringAdviceId,
) => createSelector(
  [selectDenormEntity, selectPresentAccordingToModel, selectPresentAccordingToUser, selectIsPickedDuringAdviceId],
  (denormEntity, presentAccordingToModelEntityIds, presentAccordingToUserEntityIds, isPickedDuringAdviceId) => denormEntity.map((entity) => ({
    ...entity,
    isPresentAccordingToModel: presentAccordingToModelEntityIds.includes(entity.id),
    isPresentAccordingToUser: presentAccordingToUserEntityIds.includes(entity.id),
    isPickedDuringAdvice: isPickedDuringAdviceId.includes(entity.id),
  })),
);

export const makeSelectWithPresentAccordingToUserFilter = (
  selectDenormEntity, isPresentAccordingToUser,
) => createSelector(
  selectDenormEntity,
  (entity) => entity
    .filter((entity) => entity.isPresentAccordingToUser === isPresentAccordingToUser),
);

export const makeSelectEntityWithIsPickedDuringAdviceFilter = (
  selectDenormEntity, isPickedDuringAdvice,
) => createSelector(
  selectDenormEntity,
  (entity) => entity.filter((entity) => entity.isPickedDuringAdvice === isPickedDuringAdvice),
);

export const makeSelectEntityWithAdvice = (
  selectDenormEntity, selectAdvice,
) => createSelector(
  [selectDenormEntity, selectAdvice],
  (denormEntity, adviceObj) => denormEntity.map((entity) => {
    let impact;
    if (adviceObj === null || adviceObj === undefined) {
      impact = 'Niet beschikbaar';
    } else if (!adviceObj[entity.id]) {
      impact = 0;
    } else {
      impact = adviceObj[entity.id];
    }
    return {
      ...entity,
      impact,
    };
  }),
);
